let api    = require('./api')
let domain = require('./domain')

const envMap = {
  development: 'dev',
  test: 'test',
  production: 'pro'
}

module.exports =  {
  // 开发环境下的API
  api_dev: api.dev,
  // 生产环境下的API
  api_pro: api.pro,
  // 开发环境下的域名
  domain_dev: domain.dev,
  // 生产环境下的域名
  domain_pro: domain.pro,
  // API根据前台环境自动适配
  api: api[envMap[process.env.NODE_ENV]],
  // 域名根据前台环境自动适配
  domain: domain[envMap[process.env.NODE_ENV]],
}




//////////////////
// WEBPACK FOOTER
// ./ui-domain/index.js
// module id = bHXv
// module chunks = 101